export function Donut({ percentage = 72, size = 120, stroke = 12, color = "#0d84e3", bg = "#eee" }) {
  const radius = (size - stroke) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (percentage / 100) * circumference;

  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      style={{ display: "block" }}
    >
      {/* background circle */}
      <circle
        cx={size / 2}
        cy={size / 2}
        r={radius}
        stroke={bg}
        strokeWidth={stroke}
        fill="none"
      />

      {/* progress arc */}
      <circle
        cx={size / 2}
        cy={size / 2}
        r={radius}
        stroke={color}
        strokeWidth={stroke}
        fill="none"
        strokeDasharray={circumference}
        strokeDashoffset={offset}
        strokeLinecap="round"
        transform={`rotate(-90 ${size / 2} ${size / 2})`}
        style={{ transition: "stroke-dashoffset 0.5s ease" }}
      />


      {/*  percentage */}
      <text
        x="50%"
        y="48%"
        textAnchor="middle"
        dominantBaseline="middle"
        fontSize={size * 0.25}
        fontWeight="600"
        fill="#333"
      >
        {percentage}%
      </text>

      
      <text
        x="54%"
        y="62%"
        textAnchor="middle"
        dominantBaseline="middle"
        fontSize={size * 0.10}
        fill="#666"
      >
        CO₂e saved *
      </text>
    </svg>
  );
}